// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"446baa0e","500":"97643c27","663":"95e2795f"}[chunkId] + ".bundle.js";
};